import { cn } from '@/utils/cn';
import { Info, AlertTriangle, Sparkles, RefreshCw } from 'lucide-react';

interface BannerPreviewProps {
  title: string;
  type: string;
}

const icons = {
  info: Info,
  warning: AlertTriangle,
  feature: Sparkles,
  update: RefreshCw,
};

const styles = {
  info: 'bg-primary-500/10 border-primary-500/25 text-primary-700 dark:text-primary-300',
  warning: 'bg-warning-500/10 border-warning-500/25 text-warning-600 dark:text-warning-400',
  feature: 'bg-success-500/10 border-success-500/25 text-success-600 dark:text-success-400',
  update: 'bg-neutral-500/10 border-neutral-500/25 text-neutral-700 dark:text-neutral-300',
};

export function BannerPreview({ title, type }: BannerPreviewProps) {
  const Icon = icons[type as keyof typeof icons] || Info;
  const style = styles[type as keyof typeof styles] || styles.info;

  return (
    <div className={cn('flex items-center gap-3 rounded-lg border px-4 py-3', style)}>
      <Icon className="h-4 w-4 shrink-0" />
      <p className="text-sm">{title || 'Apercu de la banniere...'}</p>
    </div>
  );
}
